export interface TansportUiModel {
    id: number;
    profile: string;
    type: string;
    transport: string;
    img: string
}

export class Transports {
    public static get(): Array<TansportUiModel> {
        return [
            {
                id: 1,
                profile: 'foot',
                type: 'foot',
                img: 'assets/svg/transports/1.svg',
                transport: 'foots',
            },
            {
                id: 2,
                profile: 'bike',
                type: 'bicycle',
                img: 'assets/svg/transports/2.svg',
                transport: 'bike',
            },
            {
                id: 3,
                profile: 'moped',
                type: 'bicycle',
                img: 'assets/svg/transports/3.svg',
                transport: 'moto',
            },
            {
                id: 4,
                profile: 'schoolbus',
                type: 'car',
                img: 'assets/svg/transports/4.svg',
                transport: 'bus',
            },
            {
                id: 5,
                profile: 'train',
                type: 'car',
                img: 'assets/svg/transports/5.svg',
                transport: 'train',
            },
            {
                id: 4,
                profile: 'bus_tram_metro',
                type: 'car',
                img: 'assets/svg/transports/6.svg',
                transport: 'express',
            },
            {
                id: 5,
                profile: 'car',
                type: 'car',
                img: 'assets/svg/transports/7.svg',
                transport: 'car',
            },
            {
                id: 6,
                profile: 'other',
                type: 'car',
                transport: 'other',
                img: 'assets/svg/transports/8.svg'
            }
        ];
    }

    public static valueOf(profile: string): TansportUiModel {
        return this.get().find(it => it.profile === profile);
    }
}
